import React from 'react';
import { IconStroke, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/radio-checked.svg';

export default function RadioCheckedIcon(props: IconProps) {
  return <IconStroke icon={Icon} {...props} />;
}
